module.exports = __webpack_public_path__ + "img/kr-product-agency-card2-img3.dc7f54b.png";